import React from 'react';
import Input from '../../../Core/Fields/Floating/Input';
import Date from '../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../Core/Fields/Floating/SelectSearch';

const GeneralDetailsTab1 = ({ formData, onFieldChange, extraData }) => {
    // console.log(extraData.customerTypes, "customerTypes");

    return (
        <div>
            <div className="px-4 py-4" style={{ background: 'white' }}>
                <div style={{ display: 'flex', gap: '20px' }} >
                    <div style={{ width: '50%' }} >
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Input label="Series" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input label="Customer" style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Date label="Date of Visit" style={{ height: "30px" }} value={formData.date_of_visit} onChange={(e) => onFieldChange('date_of_visit', e.target.value)} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch label="Company" style={{ height: "30px" }} value={formData.company}
                                        list={extraData.compnay}
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        createNewUrl="/master/itemgroup/create-item-group"
                                        createNewLabel="Create New Item Group"
                                        onChange={(val) => onFieldChange('company', val)}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ width: '50%' }} >
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Input
                                        label="Contact No "
                                        style={{ height: "30px" }}
                                        value={formData.contact_no}
                                        onChange={(e) => onFieldChange('contact_no', e.target.value)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={extraData.customer_types}
                                        label="Customer Type"
                                        style={{ height: "30px" }}
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={formData.customer_type}
                                        onChange={(val) => onFieldChange('customer_type', val)}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px', marginBottom: '10px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        label="Assigned To"
                                        list={extraData.assigned_to}

                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        style={{ height: "30px" }}
                                        value={formData.assigned_to}
                                        onChange={(val) => onFieldChange('assigned_to', val)}

                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        label="Help By"
                                        list={extraData.helped_by}

                                        style={{ height: "30px" }}
                                        value={formData.help_by}
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        onChange={(val) => onFieldChange('help_by', val)}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-4 py-2" style={{ height: '50px', background: '#efefef' }}>

            </div>
        </div>
    );
};

export default GeneralDetailsTab1;